<template>
  <div class="viewport viewport-with-top-nav viewport-compact align-items-center justify-content-center">
    <spinner v-if="loading"></spinner>
    <template v-else>
      <top-nav></top-nav>
      <otp @otp-success="onOtpSuccess" :pin="pin" v-if="pin"></otp>
      <div class="small text-muted-more mt-3 px-5">
        {{$t('LoginOtpPage.phoneNumberNotValidPleaseVisit')}}
        <router-link :to="{name: 'branches'}">{{$t('LoginOtpPage.anyOfOurBranches')}}</router-link>
      </div>
    </template>
  </div>
</template>

<script>
import store from '@shared/store'
import Otp from '@shared/components/Otp'
import TopNav from '@shared/components/TopNav'
import LoanApplicationMixin from '@shared/mixins/LoanApplicationMixin'
import UserMixin from '@shared/mixins/UserMixin'

export default {
    components: { Otp, TopNav },
    mixins: [LoanApplicationMixin, UserMixin],
    data() {
      const application = store.getApplication()
      return {
        loading: true,
        pin: application && application.borrower && application.borrower.pin
      }
    },
    async mounted () {
      if (!this.pin) {
        await this.$router.replace({ name: 'home' })
      } else {
        this.signIn()
      }
    },
    methods: {
      signIn() {
        this.signInRequest(this.pin)
            .then(() => {
              this.loading = false
            })
            .catch((e) => {
              console.log(`[login otp page] sign in failed: ${e}`)
              this.$router.back()
            })
      },
      onOtpSuccess() {
        this.loading = true
        this.getAndStoreCustomerProfile(this.pin)
            .then(this.submitAsReturningCustomer)
            .then(() => {
              this.$router.replace({ name: 'no-back', params: { page: 'thank-you-for-loan-application' } })
            })
            .catch(() => {
              this.$errorToast(this.$t('errors.application.title'), this.$t('errors.application.content'))
              this.$router.replace({ name: 'no-back', params: { page: 'customer-overview' } })
            })
      }
    }
  }
</script>
